module.exports = __webpack_public_path__ + "img/daizy_housing.16c49c42.jpg";